import React, { useState } from "react";
import { useNavigate } from "react-router";
import { MoreHorizontal, User } from "lucide-react";
import { ref, remove } from "firebase/database";

import { database } from "../../../firebase/firebase";
import { useNotification } from "../../../contexts/NotificationContext";
import BottomSheetModal from "./BottomSheetModal";
import { BookingModal } from "./BookingModal";

interface Props {
  booking: any;
  driver?: any;
  vehicle?: any;
}

export function BookingHeader({ booking, driver, vehicle }: Props) {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const handleDelete = () => {
    remove(ref(database, `booking/${booking.id}`))
      .then(() => {
        showNotification("success", "Reserva excluída com sucesso!");
        setDeleteModalOpen(false);
      })
      .catch(() =>
        showNotification("error", "Um erro aconteceu ao excluir essa reserva."),
      );
  };

  return (
    <div className="flex items-center justify-between gap-3">
      <button
        type="button"
        className="flex min-w-0 flex-1 items-center gap-2 rounded-xl bg-white/5 px-3 py-1.5 text-left text-white transition hover:bg-white/10"
        onClick={() => navigate(`/admin-management/edit/${booking.id}`)}
      >
        <User className="h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">{booking.name}</p>
        </div>
      </button>
      <button
        type="button"
        onClick={() => setBottomSheetOpen(true)}
        className="rounded-full border border-white/20 p-1.5 text-white hover:bg-white/10"
      >
        <MoreHorizontal className="h-4 w-4" />
      </button>
      <BottomSheetModal
        open={bottomSheetOpen}
        booking={booking}
        driver={driver}
        vehicle={vehicle}
        handleClose={() => setBottomSheetOpen(false)}
        handleOpenModal={() => setDeleteModalOpen(true)}
      />
      <BookingModal
        open={deleteModalOpen}
        handleClose={() => setDeleteModalOpen(false)}
        handleDelete={handleDelete}
      />
    </div>
  );
}
